module.exports = __webpack_public_path__ + "static/media/gabbu.bf4d7112.jpeg";